import { render } from "./TopRowWeekComponent.vue?vue&type=template&id=401d8afb"
import script from "./TopRowWeekComponent.vue?vue&type=script&lang=js"
export * from "./TopRowWeekComponent.vue?vue&type=script&lang=js"

import "./TopRowWeekComponent.vue?vue&type=style&index=0&id=401d8afb&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__